var returnProduct = "https://shopfront-cdn.tekoapis.com/static/ea6d2b8854995476.svg";

export { returnProduct as default };
